import { createORPCClient } from "@orpc/client";
import type { ContractRouterClient } from "@orpc/contract";
import { filesContract, type FilesContract } from "@typedoc/contracts/files/contract";
import { contractLink, type ContractCallContext } from "../contract-client";

export type FilesApiClient = ContractRouterClient<FilesContract, ContractCallContext>;

/** The Files API through its contract; each call names its region and token. */
export const filesApiClient: FilesApiClient = createORPCClient(contractLink(filesContract));
